import Modal from './Modal'

const StatusCell = ({ row }) => {
  let cellOutput;
  if (row.status === 'errored') {
    cellOutput = (
      <>
        <label htmlFor="modal-1" className="button button--warning">{row.status}</label>
        <Modal title={row.status} message={row.error} />
      </>
    )
  } else {
    cellOutput = row.status
  }
  return cellOutput;
}

export default StatusCell;